import { all } from "redux-saga/effects";
import authSaga from './authSaga'
import staffSaga from './staffSaga'
import customerSaga from './customerSaga'
import tourTypeSaga from './tourTypeSaga'
import newsCategoriesSaga from "./newsCategoriesSaga"
import newsSaga from "./newsSaga"
import tourSaga from "./tourSaga"
import searchSaga from "./searchSaga"
import homeSaga from "./homeSaga"
import tourDetailSaga from "./tourDetailSaga"
import tourOrderSaga from "./tourOrderSaga"
import favoriteSaga from "./favoriteSaga"
import rattingCommentSaga from "./rattingCommentSaga"
import commentSaga from "./commentSaga"

export default function* rootSaga() {
  yield all(
    [
      authSaga(),
      staffSaga(),
      customerSaga(),
      tourTypeSaga(),
      newsCategoriesSaga(),
      newsSaga(),
      tourSaga(),
      searchSaga(),
      homeSaga(),
      tourDetailSaga(),
      tourOrderSaga(),
      favoriteSaga(),
      rattingCommentSaga(),
      commentSaga()
    ]
  )
}
